module.exports = __webpack_public_path__ + "img/poziom5.ed15fd08.svg";